import { BasicMoreSettings } from './BasicMoreSettings'
import { DecimalPlaces } from './shared'
import { lib } from '@gocanvas/client'
const {
  NUMBER_STYLE,
  CURRENCY_STYLE,
} = lib

export const NumberMoreSettings = entry => {
  return (
    <>
      {[NUMBER_STYLE, CURRENCY_STYLE].includes(entry.style) && (
        <div className="settings--row">
          <DecimalPlaces {...entry} />
        </div>
      )}
      <BasicMoreSettings {...entry} />
    </>
  )
}
